import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ppm365RoutingModule } from './ppm365-routing.module';
import { DonorCareReportComponent } from './donor-care-report/donor-care-report.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    Ppm365RoutingModule,
    DonorCareReportComponent
  ]
})
export class Ppm365Module { } 